module.exports = __webpack_public_path__ + "img/ill_4.14d7c777.png";